<!-- Copyright by the Spark Development Network; Licensed under the Rock Community License -->
<template>
    <NotificationBox v-if="options.caption" alertType="warning">{{ options.caption }}</NotificationBox>

    <div class="actions">
        <RockButton
                    :btnType="BtnType.Link"
                    :disabled="disabled"
                    @click="onPreviousClicked">Previous</RockButton>
        <RockButton
                    :btnType="BtnType.Primary"
                    class="ml-1"
                    :disabled="disabled"
                    @click="onEmailUsernameClicked">Yes, send it</RockButton>
        <RockButton
                    :btnType="BtnType.Primary"
                    class="ml-1"
                    :disabled="disabled"
                    @click="onSendToLoginClicked">No, just let me log in</RockButton>
    </div>
</template>

<script setup lang="ts">
    import { PropType } from "vue";
    import NotificationBox from "@Obsidian/Controls/notificationBox.obs";
    import RockButton from "@Obsidian/Controls/rockButton";
    import { BtnType } from "@Obsidian/Enums/Controls/btnType";
    import { AccountEntryExistingAccountStepBag } from "@Obsidian/ViewModels/Blocks/Security/AccountEntry/accountEntryExistingAccountStepBag";

    const props = defineProps({
        disabled: {
            type: Boolean as PropType<boolean>,
            required: false,
            default: false
        },
        options: {
            type: Object as PropType<AccountEntryExistingAccountStepBag>,
            required: true
        }
    });

    const emit = defineEmits<{
        (e: "movePrevious"): void,
        (e: "emailUsername"): void,
        (e: "sendToLogin"): void
    }>();

    //#region Values

    //#endregion

    //#region Event Handlers

    /**
     * Event handler for the "Yes, send it" button being clicked.
     */
    function onEmailUsernameClicked(): void {
        emit("emailUsername");
    }

    /**
     * Event handler for the previous button being clicked.
     */
    function onPreviousClicked(): void {
        emit("movePrevious");
    }

    /**
     * Event handler for the "No, just let me log in" button being clicked.
     */
    function onSendToLoginClicked(): void {
        emit("sendToLogin");
    }

                    //#endregion
</script>